import PropTypes from 'prop-types';
import React from 'react';
import {percent, prettyNumber} from 'js/common/string_helper';

const ThumbnailCenter = ({
    koer,
    showKoer,
    engagementRate
}) => {
    const koerNumber = prettyNumber(koer, 1);

    const calculateEngagementRate = () => {
        return engagementRate ? percent(engagementRate) : 'N/A'
    }

    if (showKoer) {
        return (
            <div className="engagement-rate">
                <div>{koerNumber}</div>
                <div>KOER</div>
                <div className="engagement-rate-sm">
                    <div>{calculateEngagementRate()}</div>
                    <div>Engagement Rate</div>
                </div>
            </div>
        );
    }

    return (
        <div className="engagement-rate">
            <div>{calculateEngagementRate()}</div>
            <div>Engagement Rate</div>
        </div>
    );
};

ThumbnailCenter.propTypes = {
    koer: PropTypes.number,
    showKoer: PropTypes.bool,
    engagementRate: PropTypes.number
};

export default ThumbnailCenter;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/post_grid_item/thumbnail_center.js